export default __webpack_public_path__ + "static/media/Lily Carter.0b94a22d.jpg";